// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

import styled from '@emotion/styled';
import { ToastViewport as GlideToastViewport } from '@kintent/glide';

const ToastViewport = styled(GlideToastViewport)`
  position: fixed;
  top: 24px;
  right: 64px;
  z-index: 10000;
`;

export const Styled = {
  ToastViewport,
};
